import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { useNamespaceCopy } from '@/i18n/ns';
import unsavedEditCopy from '@/i18n/ns/unsaved-edit';

/**
 * The workspace's one leave question: every exit that would drop unsaved
 * edits (a docked canvas, a page editor such as Knowledge's, the sidebar,
 * New chat, Recent chats, browser Back) asks with the same words.
 */
export function CanvasLeaveDialog({
  open,
  onCancel,
  onDiscard,
}: {
  open: boolean;
  onCancel: () => void;
  onDiscard: () => void;
}) {
  const copy = useNamespaceCopy(unsavedEditCopy);
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <DialogContent
        showCloseButton={false}
        className="max-w-[calc(100%-2rem)] gap-5 p-5 sm:max-w-sm"
      >
        <div className="flex flex-col gap-2">
          <DialogTitle>{copy.title}</DialogTitle>
          <DialogDescription>{copy.description}</DialogDescription>
        </div>
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onCancel}
            className="min-h-11 rounded-md border px-4 text-sm font-medium"
          >
            {copy.keepEditing}
          </button>
          <button
            type="button"
            onClick={onDiscard}
            className="min-h-11 rounded-xl bg-destructive px-4 text-sm font-semibold text-destructive-foreground"
          >
            {copy.discard}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
